module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI1OWIzODgzMzk0NDdjYTg0OTc1ZmY4ODNkMmQ4M2ZhMC5zdmciOw=="